import React from 'react';

import useHotkeys from '@lyearn/core/hooks/useHotkeys';
import { useTranslation } from '@lyearn/i18n';
import { SearchOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';

export interface SearchTriggerProps {
  className?: string;
  onOpen: () => void;
}

const HOTKEYS = 'meta+k, ctrl+k';

const SearchTrigger = (props: SearchTriggerProps) => {
  const { className, onOpen } = props;
  const { t } = useTranslation();

  useHotkeys(HOTKEYS, onOpen, { enableOnFormTags: true, preventDefault: true }, [onOpen]);

  return (
    <button
      aria-keyshortcuts="Meta+K Control+K"
      className={cn(
        'flex h-30 w-[30rem] max-w-full cursor-pointer items-center gap-8 rounded-8 border border-border bg-bg-primary ps-12 pe-8 hover:bg-bg-hover',
        className,
      )}
      type="button"
      onClick={onOpen}>
      <SearchOutline className="h-16 w-16 flex-shrink-0" fillColorToken="icon-placeholder" />
      <Typography
        as="span"
        className="flex-1 truncate text-start"
        color="text-text-placeholder"
        variant="body-short-03">
        {t('Common:Search')}
      </Typography>
      <Box
        aria-hidden
        className="flex-shrink-0 rounded-4 border border-divider px-4"
        component="kbd">
        <Typography as="span" color="text-text-secondary" variant="body-short-03">
          ⌘K
        </Typography>
      </Box>
    </button>
  );
};

export default React.memo(SearchTrigger);
